import EmitEvent, {
    HEADER_DEFAULT,
    HEADER_UPDATE_COLOR,
    HEADER_WHITE,
    PAGE_LOADED,
    SMOOTH_SCROLLING
} from "../../../libs/emit-event";
import services from "../../../libs/services";
import {checkDeviceMobile} from "../../../libs/helper";

export class SingleProduct {
    constructor() {
        this.DOM = {main: document.querySelector('.js-productSingle_header_thumbnail')};
        if (!this.DOM.main) return;

        this.isColor = 'white';
        this.scrolling = this.scrolling.bind(this);
        this.pageEnter = this.pageEnter.bind(this);
        this.bindEvent();
    }

    scrolling({instance}) {

        if (!checkDeviceMobile()) {
            const disTop = Math.abs(instance) * .5;
            if (disTop < services.winSize.height) {
                this.DOM.main.style.transform = `translate3d(0, ${Math.abs(disTop)}px, 0)`;
            }
        }

        let tmpColor = 'white';
        if (Math.abs(instance) > this.prop.height - 120) {
            tmpColor = 'black';
        }
        if (tmpColor !== this.isColor) {
            EmitEvent.emit(HEADER_UPDATE_COLOR, {color: tmpColor});
            this.isColor = tmpColor;
        }
    }

    pageEnter() {
        const {height} = this.DOM.main.getBoundingClientRect();
        this.prop = {height};
    }

    bindEvent() {
        EmitEvent.on(SMOOTH_SCROLLING, this.scrolling);
        EmitEvent.on(PAGE_LOADED, this.pageEnter);
    }

    removeEvent() {
        EmitEvent.off(SMOOTH_SCROLLING, this.scrolling);
        EmitEvent.off(PAGE_LOADED, this.pageEnter);
    }
}